import React from "react";
import PropTypes from "prop-types";

const YesNoRadioButton = props => {
	const { id, name, handleChange, checked, label } = props;
	const idNo = `${id}-no`;
	const idYes = `${id}-yes`;
	const { lang } = global;
	return (
		<>
			<div className="row">
				<div className="col-xs-12">{label}</div>
			</div>
			<div className="row">
				<div className="col-xs-12">
					<div className="row">
						<div className="col-xs-2 col-sm-1">
							<div className="radio">
								<label htmlFor={idNo}>
									<input
										type="radio"
										name={name}
										id={idNo}
										onChange={() => handleChange(false)}
										checked={checked === false}
									/>
									{lang.t("No")}
								</label>
							</div>
						</div>
						<div className="col-xs-2 col-xs-offset-1 col-sm-1 col-sm-offset-0">
							<div className="radio">
								<label htmlFor={idYes}>
									<input
										type="radio"
										name={name}
										id={idYes}
										onChange={() => handleChange(true)}
										checked={checked === true}
									/>
									{lang.t("Yes")}
								</label>
							</div>
						</div>
					</div>
				</div>
			</div>
		</>
	);
};

YesNoRadioButton.propTypes = {
	id: PropTypes.string.isRequired,
	name: PropTypes.string.isRequired,
	handleChange: PropTypes.func.isRequired,
	checked: PropTypes.bool,
	label: PropTypes.string.isRequired,
};

YesNoRadioButton.defaultProps = {
	checked: false,
};

export default YesNoRadioButton;
